const NotFound = () => {
    return <h2 className="text-center text-danger">Khong tim thay trang</h2>;
}

export default NotFound;
